import { Component, Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { CellClickEvent } from '@progress/kendo-angular-grid';

@Component({
  selector: 'cp-quote-search-results',
  templateUrl: './quote-search-results.component.html',
  styleUrls: ['./quote-search-results.component.scss']
})
export class QuoteSearchResultsComponent {
  SearchTarget: SearchTarget;
  @Input() searchFilter: string;
  @Input() loading: boolean = false;
  @Input() resultsData: any;
  @Input() searchTarget: SearchTarget = SearchTarget.quote;
    @Input() isZuggitUser: boolean = false;
  @Output() cellClickEvent = new EventEmitter<CellClickEvent>();
  @Output() closeSearchResultsEvent = new EventEmitter<null>();

  skip: number = 0;
  cellClick(dataItem: CellClickEvent) {
    this.cellClickEvent.emit(dataItem);
  }
  onCloseSearchResults() {
    this.closeSearchResultsEvent.emit(null);
  }
}